import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useLoggedUserStore } from "./LoggedUserStore";
import { usePublicUserMenuStore } from "./PublicUserMenuStore";
import { usePublicUserStore } from "./PublicUserStore";
//@ts-ignore
import { onUserStatusSet } from "@utils/GTM_Events";
import { defineStore } from "pinia";
export var useBasePublicUserStore = defineStore("basePublicUserStoreId", () => {
  var loggedUserStore = useLoggedUserStore();
  var publicUserMenuStore = usePublicUserMenuStore();
  var publicUserStore = usePublicUserStore();
  var initPublicUserStoreLogged = () => __awaiter(void 0, void 0, void 0, function* () {
    yield publicUserMenuStore.getPublicUserMenuInfo();
    yield publicUserStore.getPublicUser();
  });
  var logout = () => __awaiter(void 0, void 0, void 0, function* () {
    var res = yield loggedUserStore.doLogout();
    if (!res) return;
    publicUserStore.resetPublicUserStore();
    publicUserMenuStore.resetPublicUserMenuStore();
  });
  var initPublicUserStore = () => __awaiter(void 0, void 0, void 0, function* () {
    yield loggedUserStore.checkIfUserIsLogged();
    if (!loggedUserStore.isUserLogged) {
      onUserStatusSet();
      return false;
    }
    yield initPublicUserStoreLogged();
    onUserStatusSet(publicUserStore.userEmail);
    return true;
  });
  var initPublicUserMenu = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield initPublicUserStore();
  });
  return {
    initPublicUserStoreLogged,
    initPublicUserStore,
    initPublicUserMenu,
    logout
  };
});